import { Button } from "@mui/material";

const ExportDataButton = ({ onClick, disabled, label = "Export Current Data" }) => {
  return (
    <Button
      variant={disabled ? "contained" : "outlined"}
      color={disabled ? "primary" : "inherit"}
      sx={{
        pr: 1.5,
        pl: 1,
        py: 0,
        lineHeight: "35px",
        borderRadius: "20px",
      }}
      startIcon={<img src={`assets/buttons/export${disabled ? "-disabled" : ""}.svg`} alt="Export" />}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default ExportDataButton;
